import React from 'react';
import { Link } from 'react-router-dom';
import { School, User, CalendarDays, ArrowRight } from 'lucide-react';
import { useYearContext } from '../components/Layout.jsx';
import RichText from '../lib/RichText.jsx';

export default function Home() {
  const { year, basePath } = useYearContext();
  const href = (to) => `${basePath}/${to}`;

  return (
    <>
      <section className="hero">
        <h1>Seminář z informatiky</h1>
        <div className="hero-meta">
          <span><CalendarDays size={15} aria-hidden="true" />Školní rok {year.label}</span>
          {year.school && <span><School size={15} aria-hidden="true" />{year.school}</span>}
          {year.teacher && <span><User size={15} aria-hidden="true" />{year.teacher}</span>}
        </div>
      </section>

      {year.syllabus?.length > 0 && (
        <section className="stack-lg" style={{ marginBottom: '3rem' }}>
          <div>
            <div className="section-title"><h2>Sylabus</h2></div>
            <ol className="syllabus">
              {year.syllabus.map((item, index) => <li key={index}>{item}</li>)}
            </ol>
          </div>

          <div className="chip-row">
            <Link to={href('hodiny')} className="chip">Hodiny <ArrowRight size={14} /></Link>
            <Link to={href('ukoly')} className="chip">Úkoly <ArrowRight size={14} /></Link>
            <Link to={href('materialy')} className="chip">Materiály <ArrowRight size={14} /></Link>
          </div>
        </section>
      )}

      {year.about?.length > 0 && (
        <section>
          <div className="section-title"><h2>O předmětu a jak k němu přistupovat</h2></div>
          <div className="prose">
            {year.about.map((paragraph, index) => <RichText key={index} text={paragraph} />)}
          </div>
        </section>
      )}
    </>
  );
}
